import React from 'react';
import {v4} from 'uuid';

// Components
import InputField from '../components/InputField';

export default (data, {direct, required, onGeneration}) => (
  <InputField
    key={v4()}
    direct={direct}
    required={required}
    onGeneration={onGeneration}
  />
);
